<div class="post-login-2">
  <div class="post-login-2-col-1 h-100">
    <left-panel activeTab="0"></left-panel>
  </div>
  <div class="post-login-2-col-2 p-0 h-100 has-banner overflow-y-hidden">
    <img src="~/../assets/images/left-banner.jpg" style="height: 100%; min-width: 100%;" alt="">
  </div>
  <div class="post-login-2-col-3 bg-base-100">
    <div class="p-20 confirm-page">

      <!-- Header bar: back caret + page title (mobile #7) -->
      <div class="confirm-header">
        <button class="confirm-back" (click)="back()">
            <i class="icon-back"></i>
        </button>
        <div class="confirm-title">
            {{ "ConfirmRedemption" | translate }}
        </div>
        <div class="confirm-back-spacer"></div>
      </div>

      <!-- Review & confirm sub-header -->
      <div class="mt-24">
        <div class="font-600 font-size-18px line-h-24 color-base-1700">
            {{ "ReviewAndConfirm" | translate }}
        </div>
        <div class="font-400 font-size-13px line-h-20 color-base-500 mt-5">
            {{ "ReviewAndConfirmSub" | translate }}
        </div>
      </div>

      <!-- Dark green summary card: "YOU'RE REDEEMING" + points + BHD equivalent -->
      <div class="confirm-green-card mt-20">
        <div class="font-500 font-size-11px line-h-16 color-base-2200 text-uppercase letter-spacing-1 confirm-green-label">
            {{ "YOUAREREDEEMING" | translate }}
        </div>
        <div class="font-700 font-size-32px line-h-38 color-base-100 mt-8 confirm-green-points">
            {{ selectedPoint | number }}
            <span class="font-500 font-size-14px line-h-20">{{ "points" | translate }}</span>
        </div>
        <div class="font-500 font-size-13px line-h-18 confirm-green-equivalent mt-4" *ngIf="isGiveBack">
            {{ "EquivalentTo" | translate }} BHD {{ formattedAmount }} donation
        </div>
        <div class="font-500 font-size-13px line-h-18 confirm-green-equivalent mt-4" *ngIf="!isGiveBack && formattedAmount && formattedAmount !== '0'">
            {{ "EquivalentTo" | translate }} BHD {{ formattedAmount }}
        </div>
      </div>

      <!-- Detail rows: Redeem to / Reward type / Points used / Value -->
      <div class="confirm-detail-rows mt-20">
        <div class="confirm-detail-row">
            <div class="confirm-detail-label">{{ "Redeemto" | translate }}</div>
            <div class="confirm-detail-value">{{ Redeemto }}</div>
        </div>
        <div class="confirm-detail-row">
            <div class="confirm-detail-label">{{ "RewardType" | translate }}</div>
            <div class="confirm-detail-value">{{ partnerCategory || Redeemto }}</div>
        </div>
        <div class="confirm-detail-row">
            <div class="confirm-detail-label">{{ "PointsUsed" | translate }}</div>
            <div class="confirm-detail-value">{{ selectedPoint | number }} {{ "points" | translate }}</div>
        </div>
        <div class="confirm-detail-row" *ngIf="isGiveBack && formattedAmount && formattedAmount !== '' && formattedAmount !== '0'">
            <div class="confirm-detail-label">{{ "Value" | translate }}</div>
            <div class="confirm-detail-value confirm-detail-value-success">{{ formattedAmount }} donation</div>
        </div>
        <div class="confirm-detail-row" *ngIf="!isGiveBack && formattedAmount && formattedAmount !== '' && formattedAmount !== '0'">
            <div class="confirm-detail-label">{{ "Value" | translate }}</div>
            <div class="confirm-detail-value confirm-detail-value-success">{{ formattedAmount }}</div>
        </div>
        <div class="confirm-detail-row" *ngIf="perPointRate && perPointRate > 0">
            <div class="confirm-detail-label">{{ "ConversionRate" | translate }}</div>
            <div class="confirm-detail-value">{{ getConfirmRateDisplay() }}</div>
        </div>
        <div class="confirm-detail-row" *ngIf="!isGiveBack && GulfnumberDisplay && GulfnumberDisplay !== ''">
            <div class="confirm-detail-label">{{ "AccountNumber" | translate }}</div>
            <div class="confirm-detail-value">{{ GulfnumberDisplay }}</div>
        </div>
        <div class="confirm-detail-row" *ngIf="!isGiveBack && shukranNumberDisplay && shukranNumberDisplay !== ''">
            <div class="confirm-detail-label">{{ "AccountNumber" | translate }}</div>
            <div class="confirm-detail-value">{{ shukranNumberDisplay }}</div>
        </div>
      </div>

      <!-- Amber warning banner: irreversibility disclaimer (mobile #7) -->
      <div class="confirm-warning mt-20">
        <div class="confirm-warning-icon">
            <ng-icon iconClass="icon-disclaimer" width="22" height="22"></ng-icon>
        </div>
        <div class="confirm-warning-text font-400 font-size-12px line-h-18 color-base-1500">
            {{ "IrreversibilityWarning" | translate }}
        </div>
      </div>

      <!-- Mandatory acknowledgement checkbox (mobile #7) -->
      <label class="confirm-checkbox mt-20">
        <input type="checkbox" [(ngModel)]="acceptTerms" />
        <span class="confirm-checkbox-box" [class.confirm-checkbox-box-checked]="acceptTerms">
            <ng-icon iconClass="icon-check-custom" width="14" height="14" *ngIf="acceptTerms"></ng-icon>
        </span>
        <span class="confirm-checkbox-label font-400 font-size-13px line-h-20 color-base-1500">
            {{ "AcceptCondition" | translate }}
        </span>
      </label>

      <!-- Action buttons: Continue (disabled until checked) + Cancel -->
      <div class="confirm-actions mt-30">
        <button class="btn-dft w-100"
                (click)="showModal(1)"
                [disabled]="!canContinue()">
            {{ "Continue" | translate }}
        </button>
        <button class="btn-dft-border w-100 mt-12" (click)="cancel()">
            {{ "Cancel" | translate }}
        </button>
      </div>

    </div>
  </div>
</div>

<!-- Disclaimer modal (kept for the existing Next() flow) -->
<modal modalID="1" modalClass="height-auto-flex" [events]="modalObservable.asObservable()" [backdropDismiss]="true"
    modalDoneButtonText="CONFIRM" (doneButton)="Next()" [whiteButtonStatus]="true" whiteButtonText="CANCEL" [modalDoneButtonStatus]="true">
    <div class="text-align-center">
        <ng-icon iconClass="icon-disclaimer" width="72" height="72"></ng-icon>
        <div class="font-400 font-size-14px line-h-20 color-base-500 p-10 mt-30">
            {{ "DearValuedCustomer" | translate }}
        </div>
        <div class="font-400 font-size-14px line-h-20 color-base-500 p-10 mt-10">
            {{ "Beforeproceedingwiththetransfer" | translate }}
        </div>
    </div>
</modal>